import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  servicesCategory: [],
  allServicesCategory: [],
  addServicesCategoryDate: [],
};

export const ServicesCategorySlice = createSlice({
  name: "servicesCategory",
  initialState,
  reducers: {
    getServicesCategoryAction: (state, action) => {
      state.allServicesCategory = action.payload;
    },
    getAddServicesCategoryDataAction: (state, action) => {
      state.addServicesCategoryDate = action.payload;
    },
    singleServicesCategoryAction: (state, action) => {
      state.servicesCategory = action.payload
    }
  },
});

export default ServicesCategorySlice.reducer;

export const { getServicesCategoryAction, getAddServicesCategoryDataAction, singleServicesCategoryAction } = ServicesCategorySlice.actions;
